// extracted by mini-css-extract-plugin
module.exports = {"container":"A3","hide":"A4","content":"A5","close":"A6","closeIcon":"A7","svgStyles":"A8"};